import { HeroIcon } from '@components/HeroIcon'
import { Progress } from '@components/Progress'
import { useTranslation } from 'react-i18next'
import { FontSizeTokens, XStack, Text, useMedia } from 'tamagui'

interface IProductProgressProps {
  progress: number
  completedLessons?: number
  totalLessons?: number
  progressBarHeight: number
  progressIndicatorColor: string
  isStarted: boolean
  isCompleted: boolean
  lessonsQuantityFontSize: FontSizeTokens
}

export function ProductProgress({
  progress,
  completedLessons,
  totalLessons,
  progressBarHeight,
  progressIndicatorColor,
  isStarted,
  isCompleted,
  lessonsQuantityFontSize,
}: IProductProgressProps) {
  const { t } = useTranslation('Home')
  const media = useMedia()

  return (
    <XStack
      position="absolute"
      width="100%"
      bottom={12}
      alignItems="center"
      gap={8}
      px={12}
      py={4}
      borderRadius={999}
    >
      <Progress
        value={progress}
        height={progressBarHeight}
        foregroundColor={progressIndicatorColor}
      />
      <XStack gap={6}>
        {isCompleted ? (
          <HeroIcon
            icon={['fal', 'check-circle']}
            color="$progress-complete"
            size={media.gtSm ? 16 : 14}
          />
        ) : (
          <>
            {isStarted && (
              <Text
                color="$progress-complete"
                ff="$mulishRegular"
                fontWeight={400}
                fontSize={lessonsQuantityFontSize}
              >
                {completedLessons}
              </Text>
            )}
            <Text
              color="$text-on-media"
              ff="$mulishRegular"
              fontWeight={400}
              fontSize={lessonsQuantityFontSize}
            >
              {isStarted ? t('myProducts.productCard.of') : ''} {totalLessons}
            </Text>
          </>
        )}
      </XStack>
    </XStack>
  )
}
